import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { InputWithLabel } from "../../../component/Form/InputWithLabel";
import UserService from "../../../services/UserService";
import { ModalMessage } from "../../../component/Modal/ModalMessage";
import Notify from "../../../services/Notify";
import Icon from "../../../component/Icon/Icon";
import ModalMessageNew from "../../../component/Modal/ModalMessageNew";

class ApplicationUserGrid {

  constructor() {
    this.userService = new UserService()
  }

  title = 'Lista de usuários';
  columns = [
    {
      Header: "Nome",
      accessor: "name",
      HeaderColumn: true,
    },
    {
      Header: "E-mail",
      accessor: "email"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => {
        const [showModal, setShowModal] = useState(false)

        const handleDeleteUser = async (userId) => {
          try {
            await this.userService.deleteById(userId)
            this.forceReload()
            Notify.success("Local deletado com sucesso!")
          } catch (error) {
            Notify.error("Houve um erro ao deletar o local, por favor tente novamente mais tarde.", error)
          } finally {
            setShowModal(false)
          }
        }

        const handleShowModal = () => setShowModal(!showModal)
        return (
          <Row>
            <Col lg={4} class="p-2">
              <Button title="Editar" href={"#/users/" + row.original.id + "/edit"} bsStyle="success" block>
                <Icon icon="pencil" />
              </Button>
            </Col>
            <Col lg={4} class="mr-2">
              <Button title="Perfis de acesso" bsStyle="primary" block href={"#/users/" + row.original.id + "/profiles"}>
                <Icon icon="users" />
              </Button>
            </Col>
            <Col lg={4}>
              <Button title="Excluir" bsStyle="danger" block onClick={handleShowModal}>
                <Icon icon="trash" />
              </Button>
            </Col>
            <ModalMessageNew
              title={`Tem certeza que deseja deletar o usuário(a) ${row.original.name} ?`}
              showModal={showModal}
              handleShowModal={handleShowModal}
              errorButtonAction={handleShowModal}
              successButtonAction={() => handleDeleteUser(row.original.id)}
            />
          </Row>
        )
      }
    }
  ];


  customFilters = { friendlyName: null , email: null}

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Nome" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e.trim()
            onChange(this.customFilters)
          }} />
        </Col>
        <Col md={6}>
          <InputWithLabel label="Email" onChangeWithDelay={e => {
            this.customFilters.email = e.trim()
            onChange(this.customFilters)
          }} />
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const { friendlyName, email } = this.customFilters

    friendlyName && params.append('name', friendlyName)
    email && params.append('email', email)

    return `auth/v1/users?${params.toString()}`
  }
}

export default ApplicationUserGrid;



// WEBPACK FOOTER //
// ./src/user/application/component/ApplicationUserGrid.js